// same promise for all calls
const _loaded = new Promise(function (resolve) {
    document.readyState === 'complete'
        ? requestAnimationFrame(function () {
            resolve();
        })
        : window.addEventListener('load', function () {
            resolve();
        });
});

export default function promiseLoaded() {
    return function (value) {
        return _loaded.then(function () {
            return value;
        });
    };
}